export default function handleError(e) {
  console.error(e);
}
